import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class SubscriptionPlan extends ApplicationRecord {
  static jsonapiType = "subscription_plans";

  @Attr() accountManager: boolean;

  @Attr() billingPeriod: string;

  @Attr() buttonId: number;

  @Attr() currency: string;

  @Attr() customFields: string;

  @Attr() email: string;

  @Attr() engagementLimitPerMonth: number;

  @Attr() handlingFeePercentage: string;

  @Attr() name: string;

  @Attr() paymentTerms: string;

  @Attr() planClass: string;

  @Attr() price: number;

  @Attr() publishableKey: string;

  @Attr() sectorsLimit: number;

  @Attr() stripeId: string;

  @Attr() taxPercent: number;

  @Attr() userLimit: number;

  @Attr() isActive: boolean;

  @Attr() canUpgradeTo: boolean;

  @Attr() canDowngradeTo: boolean;

  @Attr() changePlanId: string;

  @Attr() changePlanPath: string;

  @Attr() downgradable: boolean;

  @Attr() upgradable: boolean;

  @Attr() popular: boolean;

  @Attr() videoInterviewing: boolean;
}

export default SubscriptionPlan;
